import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';
import en from './en.json';
import tr from './tr.json';

export type Locale = 'ru' | 'en' | 'tr';

const STORAGE_KEY = 'qastudio.v1.ui.locale';

const detectInitial = (): Locale => {
  if (typeof window === 'undefined') return 'ru';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'ru' || stored === 'en' || stored === 'tr') return stored;
  } catch {
    /* localStorage may be blocked */
  }
  // slot_t00_ftue_rewrite (6 JUN 2026) · external tester round: browser-language
  // sniffing dropped. Genie's EN browser flipped the whole UI to English on a
  // RU invite-only pilot (ICP axiom: без английского). Default is ru; en/tr
  // remain reachable via the explicit setLocale() switcher (stored override above).
  return 'ru';
};

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    tr: { translation: tr },
  },
  lng: detectInitial(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const setLocale = (loc: Locale): void => {
  void i18n.changeLanguage(loc);
  try {
    window.localStorage.setItem(STORAGE_KEY, loc);
  } catch {
    /* localStorage may be blocked */
  }
};

export const currentLocale = (): Locale => (i18n.language as Locale) || 'ru';

export default i18n;
